import { actionCreator } from '@ardoq/rxbeach';
import type { ArdoqId } from '@ardoq/api-types';
import type { SetupStatus } from './setupStatusDetection';

export const openCreateInitiativeModal = actionCreator(
  '[transformations] OPEN_CREATE_INITIATIVE_MODAL'
);

export const closeCreateInitiativeModal = actionCreator(
  '[transformations] CLOSE_CREATE_INITIATIVE_MODAL'
);

export const openCreateFutureStateModal = actionCreator<ArdoqId>(
  '[transformations] OPEN_CREATE_FUTURE_STATE_MODAL'
);

export const openSetTargetStateModal = actionCreator<ArdoqId>(
  '[transformations] OPEN_SET_TARGET_STATE_MODAL'
);

export const openCreateChildInitiativeModal = actionCreator<ArdoqId>(
  '[transformations] OPEN_CREATE_CHILD_INITIATIVE_MODAL'
);

export const closeCreateFutureStateModal = actionCreator(
  '[transformations] CLOSE_CREATE_FUTURE_STATE_MODAL'
);

export const deleteInitiativeRequested = actionCreator<ArdoqId>(
  '[transformations] delete initiative requested'
);

export const setupStatusResolved = actionCreator<SetupStatus>(
  '[transformations] setup status resolved'
);

export const setupStatusCleared = actionCreator(
  '[transformations] setup status cleared'
);
